import cloneDeep from 'lodash/cloneDeep';

import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('events'),
  rootKey: 'event',

  parse(attributes) {
    return { rawJSON: cloneDeep(attributes), ...attributes };
  },
});



// WEBPACK FOOTER //
// ./app/models/event_payload.js